import React from 'react';

import { styled } from '../../styles';
import { MEDIUM_INPUT_HEIGHT, SMALL_INPUT_HEIGHT } from '../../theme/constants';
import { SelectItemStyled } from '../SelectItem/styled';

export const MediumSelectValue = styled(SelectItemStyled)(({ theme }) => ({
  padding: theme.spacing(0, 3),
  height: `${MEDIUM_INPUT_HEIGHT}px`,
  ...(theme.typography.body2 as React.CSSProperties),
}));

export const SmallSelectValue = styled(SelectItemStyled)(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: `${SMALL_INPUT_HEIGHT}px`,
  ...(theme.typography.body3 as React.CSSProperties),
}));

export const SelectItemPlaceholder = styled.span(({ theme }) => ({
  flex: 1,
  color: theme.palette.text3,
  textAlign: 'start',
}));
